import { apiSlice } from 'store/slices/api/api-slice';
import { CardUpdateRequest, EditCardResponse } from 'types/card/card-list';

export const editCardApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        editCard: builder.mutation<void, CardUpdateRequest>({
            query: (cardUpdateRequest: CardUpdateRequest) => ({
                url: `/card/${cardUpdateRequest.status === 'active' ? 'update-active' : 'update-draft'}/${cardUpdateRequest.cardId}`,
                method: 'PUT',
                body: { ...cardUpdateRequest },
            }),
        }),

        getCardData: builder.query<EditCardResponse, string>({
            query: (params: string) => ({
                url: `/card/card/${params}`,
                method: 'GET',
            }),
        }),
    }),
});

export const { useEditCardMutation, useGetCardDataQuery } = editCardApi;
